/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import { StringControllerResponse, StringControllerResponseFromJSON, StringControllerResponseToJSON } from "../models";

export interface ImplementationGuideGetRequest {
  client: string;
  apiVersion?: ImplementationGuideGetApiVersionEnum;
}

/**
 *
 */
export class ImplementationGuideApi extends runtime.BaseAPI {
  /**
   */
  async implementationGuideGetRaw(
    requestParameters: ImplementationGuideGetRequest,
  ): Promise<runtime.ApiResponse<StringControllerResponse>> {
    if (requestParameters.client === null || requestParameters.client === undefined) {
      throw new runtime.RequiredError(
        "client",
        "Required parameter requestParameters.client was null or undefined when calling implementationGuideGet.",
      );
    }

    const queryParameters: any = {};

    if (requestParameters.client !== undefined) {
      queryParameters["Client"] = requestParameters.client;
    }

    if (requestParameters.apiVersion !== undefined) {
      queryParameters["api-version"] = requestParameters.apiVersion;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    const response = await this.request({
      path: `/ImplementationGuide`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) => StringControllerResponseFromJSON(jsonValue));
  }

  /**
   */
  async implementationGuideGet(requestParameters: ImplementationGuideGetRequest): Promise<StringControllerResponse> {
    const response = await this.implementationGuideGetRaw(requestParameters);
    return await response.value();
  }
}

/**
 * @export
 * @enum {string}
 */
export enum ImplementationGuideGetApiVersionEnum {
  _10 = "1.0",
}
